import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Owns all New-event form state, reminder toggling, and the create/recurrence
// save. Extracted from AddEventModal to keep that component presentational.
export function useEventForm({ open, preset, onSaved }) {
  const [title, setTitle] = useState("");
  const [when, setWhen] = useState("");
  const [notes, setNotes] = useState("");
  const [kind, setKind] = useState("appointment");
  const [recurring, setRecurring] = useState(false);
  const [freq, setFreq] = useState("weekly");
  const [interval, setIntervalV] = useState("1");
  const [count, setCount] = useState("6");
  const [reminders, setReminders] = useState([60]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (open && preset && !when) {
      const p = preset;
      setWhen(`${p.getFullYear()}-${String(p.getMonth() + 1).padStart(2, "0")}-${String(p.getDate()).padStart(2, "0")} 09:00`);
    }
    if (!open) { setWhen(""); setRecurring(false); setReminders([60]); setTitle(""); setNotes(""); setKind("appointment"); }
  }, [open, preset]);

  const toggleRem = (m) => setReminders((p) => p.includes(m) ? p.filter((x) => x !== m) : [...p, m].sort((a, b) => a - b));

  const save = async () => {
    setErr(null); setBusy(true);
    try {
      const iso = new Date(when.replace(" ", "T")).toISOString();
      const payload = { title: title.trim(), starts_at: iso, kind, notes: notes.trim() || null, reminders: reminders.map((m) => ({ minutes_before: m })) };
      if (recurring) payload.recurrence = { freq, interval: Math.max(1, parseInt(interval, 10) || 1), count: Math.max(1, Math.min(52, parseInt(count, 10) || 6)) };
      await api.createEvent(payload);
      onSaved();
    } catch (ex) { setErr(ex?.message || "Invalid date/time"); }
    finally { setBusy(false); }
  };

  return {
    title, setTitle, when, setWhen, notes, setNotes, kind, setKind,
    recurring, setRecurring, freq, setFreq, interval, setIntervalV,
    count, setCount, reminders, toggleRem, busy, err, save,
    canSave: !!title.trim() && !!when.trim(),
  };
}
